import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function CreditCardStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M21.25 6C21.25 5.30964 20.6904 4.75 20 4.75H4C3.30964 4.75 2.75 5.30964 2.75 6V18C2.75 18.6904 3.30964 19.25 4 19.25H20C20.6904 19.25 21.25 18.6904 21.25 18V6ZM22.75 18C22.75 19.5188 21.5188 20.75 20 20.75H4C2.48122 20.75 1.25 19.5188 1.25 18V6C1.25 4.48122 2.48122 3.25 4 3.25H20C21.5188 3.25 22.75 4.48122 22.75 6V18Z"
				fill="currentColor"
			/>
			<path
				d="M11.5 15.25C11.9142 15.25 12.25 15.5858 12.25 16C12.25 16.4142 11.9142 16.75 11.5 16.75H10C9.58579 16.75 9.25 16.4142 9.25 16C9.25 15.5858 9.58579 15.25 10 15.25H11.5ZM18 15.25C18.4142 15.25 18.75 15.5858 18.75 16C18.75 16.4142 18.4142 16.75 18 16.75H14.5C14.0858 16.75 13.75 16.4142 13.75 16C13.75 15.5858 14.0858 15.25 14.5 15.25H18Z"
				fill="currentColor"
			/>
			<path d="M22.75 8.25V9.75H1.25V8.25H22.75Z" fill="currentColor" />
		</svg>
	);
}

CreditCardStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default CreditCardStrokeIcon;
